import { useCallback, useEffect, useState } from "react";
import { MAX_RETRIES } from "../../configs/configs";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";
import useRetry from "../Common/useRetry";

function useGetNewInvoiceNo(receiptPrice) {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [invoiceNo, setInvoiceNo] = useState();

  const { retryCount, setRetryCount } = useRetry(
    () => getNewInvoiceNo(),
    MAX_RETRIES
  );

  const getNewInvoiceNo = useCallback(() => {
    fetchWrapper({
      endpoint_url: "transaction/getNewInvoiceNo",
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          let data = fetch_output["data"];
          setInvoiceNo(data);
          setRetryCount(0);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({ apiType: "fetch", message: "Get New Invoice Number" });

        setRetryCount((prev) => prev + 1);
      },
      onResponseError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "response",
            message: "Get New Invoice Number",
          });

        setRetryCount((prev) => prev + 1);
      },
    });
  }, [fetchWrapper]);

  useEffect(() => {
    if (receiptPrice.cash != null) getNewInvoiceNo();
  }, [receiptPrice?.cash]);

  return { invoiceNo };
}

export default useGetNewInvoiceNo;
